


































































































































































































































import { PropType, defineComponent, computed, ComputedRef, getCurrentInstance } from '@vue/composition-api';
import { Message, ReportData } from '../../../dataType';
import { useLocale } from '../../../hooks/useLocale';
import { useCommonHooks } from './help';
import {
  IntentCodeType,
  ReportDataType,
  CommonType,
  CustomCommonType,
  ProgressCodeType,
  StatisticType,
  ProgressType,
  GroupData
} from './type';
import { useIssue } from '../../../hooks/useIssue';
import { useRender } from '../../../hooks/useRender';
import AsyncLoading from './async-loading.vue';

export default defineComponent({
  components: {
    AsyncLoading
  },
  props: {
    message: {
      type: Object as PropType<Message<ReportData<any>>>,
      required: true
    }
  },
  setup(props) {
    const { t, tc } = useLocale();
    const instance = getCurrentInstance();
    const showDailyField: Array<('finishWork' | 'inProgressWork' | 'overDueWork') & (keyof ReportDataType)> =
      ['finishWork', 'inProgressWork', 'overDueWork'];
    const intentCode = props.message.content.report.base.intentCode as IntentCodeType;
    const reportData = computed(() => {
      return props.message.content.report.reportData as ReportDataType;
    });
    const reportType = props.message.content.report.reportType;
    const workStatisticType = computed(() => reportData.value.workStatisticType || 'point') as ComputedRef<StatisticType>;

    const {
      intentCodeTranslateMap,
      unitTranslateMap,
      transformUnitByStatisticType,
      transformIssueText,
      transformListNeedData,
      transformSummaryNeedData
    } = useCommonHooks();
    const fixedTitleMap = intentCodeTranslateMap[intentCode];

    const listMap = computed(() => {
      const final = showDailyField.filter(
        (key):Boolean => (key === 'finishWork' || reportData.value[key]!?.issueIds?.length > 0)
      );

      return final.map((key): CustomCommonType => {
        const content = (reportData.value?.[key]?.content?.length || 0) > 6 ? reportData.value[key]?.content.slice(0, 6)
          : reportData.value[key]?.content;
        return {
          type: key === 'finishWork' ? 'item' : 'group',
          key,
          ...(reportData.value[key] as CommonType),
          content: content || []
        };
      });
    });
    const { openIssue } = useIssue();
    const { openAside } = useRender();

    const openIssueDetail = (issue: number) => {
      openIssue(issue);
    };
    const openAsideComponent = (
      issueIds: Array<number>,
      type: string,
      hasGroup?: Array<GroupData> | null,
      trackType?: string,
      trackParam?: any
    ) => {
      openAside(() => import('../../aside-component/IssueList.vue'), {
        ...props.message,
        title: `${t('dashboard.ConfigurationDialog.project')}: ${reportData.value.projectName} ${t('project.With_this_Date')}: ${reportData.value.reportDate} ${type}`,
        content: {
          issueIds: issueIds,
          loadListById: true,
          hasGroup
        }
      });

      if (trackType) {
        instance?.proxy.$track.send(trackType, trackParam, true);
      }
    };

    const summaryList = computed(() => {
      const o = {
        finish: reportData.value.progress.finish,
        inProgress: reportData.value.progress.inProgress,
        overDue: {}
      };
      if (reportData.value.progress.overDue.issueCount > 0) {
        o.overDue = reportData.value.progress.overDue;
      } else {
        Reflect.deleteProperty(o, 'overDue');
      }
      return o;
    }) as ComputedRef<ProgressType>;
    const allSummaryList = computed(() => {
      const keys = Object.keys(reportData.value.progress) as Array<ProgressCodeType>;
      return keys.reduce((acc: number[], key: ProgressCodeType): Array<number> => {
        return [...acc, ...reportData.value.progress[key]?.issueIds];
      }, []);
    });
    return {
      t,
      tc,
      reportType,
      reportData,
      intentCode,
      workStatisticType,
      unitTranslateMap,
      transformUnitByStatisticType,
      fixedTitleMap,
      listMap,
      openIssueDetail,
      openAsideComponent,

      summaryList,
      allSummaryList,
      transformIssueText,
      transformListNeedData,
      transformSummaryNeedData
    };
  }
});
